import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Training } from 'src/app/models/training.model';

@Component({
  selector: 'app-training-delete-dialog',
  templateUrl: './training-delete-dialog.component.html',
  styleUrls: ['./training-delete-dialog.component.scss']
})
export class TrainingDeleteDialogComponent {
  
  listOfNames :Training[];

  constructor(
    public dialogRef: MatDialogRef<TrainingDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataTraining,
    private router: Router,
  ) {  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  rerouteToTraining(trainingName: string) {
    localStorage.setItem('filteredTrainingId', trainingName);
    this.router.navigate(['/training']);
    this.dialogRef.close();

  }

}
  
  export interface DialogDataTraining {
  title: string;
  message: string;
  listOfTrainings: Training[];
}
